import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../notifications/toast.service';
import { AuthService } from './auth.service';
import { MultiSesionService } from './multi-sesion.service';
import { SessionStore } from './session.store';

/** Version que se reporta al backend, igual que el `client-version` de FrontKordata. */
const CLIENT_VERSION = '1.0.0';

/** Errores con los que el backend indica que la sesion dejo de ser valida. */
const ERRORES_DE_SESION = ['jwt-expiret', 'jwt-revoked', 'Missing or invalid Authorization header'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionStore);
  const multiSesion = inject(MultiSesionService);
  const auth = inject(AuthService);
  const toast = inject(ToastService);

  const token = session.token();
  const request = token
    ? req.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
          'client-version': CLIENT_VERSION,
          'url-origin': document.URL,
        },
      })
    : req;

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const mensaje = (error.error as { messageError?: string } | null)?.messageError;

      if (error.status === 401 || (mensaje && ERRORES_DE_SESION.includes(mensaje))) {
        multiSesion.eliminarTodas();
        auth.irALoginDeKordata();
      } else if (!req.headers.has('x-skip-toast')) {
        toast.errorHttp(error);
      }

      return throwError(() => error);
    })
  );
};
